import Decimal from 'decimal.js';
import Numeric from '@/core/types/Numeric';
import Title_ru_RU_Class from "@/core/misc/decorators/Title_ru_RU_Class";

/**
 * Операции с участием курса (Sum × Rate, и др.) объявлены на типах-операндах
 * (Sum.mul(Rate)), а не здесь — направление операции диктует операнд, не курс.
 */
@Title_ru_RU_Class('Курс')
class CurrencyRate extends Numeric {
    static readonly SCALE = 8;

    static fromServer(value: string): CurrencyRate {
        return new CurrencyRate(value);
    }

    /** Результат вычисления — уже посчитанный Decimal. */
    static fromOperation(value: Decimal): CurrencyRate {
        return new CurrencyRate(value);
    }

    /** Курс для отображения — 4 знака с округлением. Хранится со scale 8 для
     * точности расчётов, но показывать удобнее короче. Без разделителей
     * разрядов: курс не денежная величина, группировка тысяч не нужна. */
    format(): string {
        if (this.isEmpty()) {
            return '';
        }

        return this.value.toFixed(4);
    }
}

export default CurrencyRate;